import React, { useState } from 'react';
import { SendMessage } from './App.js'

import icoDel from './img/ico-del.svg';
export default function DanmuTextCard({ mode, index, text, setQuota }) {

  const [isTouching, setIsTouching] = useState(false);
  const [canSend, setCanSend] = useState(true);

  const handleTouchStart = () => {
    //console.log('Image touched down');
    // Set isTouching to true to indicate touch is started
    setIsTouching(true);
    // Additional logic if needed
  };

  const handleTouchEnd = () => {
    //console.log('Image released');
    // Set isTouching to false to indicate touch is ended
    setIsTouching(false);
    // Additional logic if needed
  };

  const handleImageClick = () => {
    if (mode === 1 && canSend) { //used by public table menu for the normal customer
      SendMessage(`[{"type":"DANMU_MESSAGE","msg":"${text}"}]`);
      setCanSend(false); // Disable sending temporarily
      setTimeout(() => {
        setCanSend(true); // Re-enable sending after a cooldown period
      }, 1000); // Adjust the cooldown period (in milliseconds) as needed
    } else if (mode === 2) {
      setQuota(text); //used by the 147 menu for the message sending
    }
  };

  return (
    <><div 
          style={{ 
            padding: "10px", 
            width: "100%",
            display: "flex",         // Enables flexbox layout
            alignItems: "center",     // Vertically aligns link text and icon
            justifyContent: "space-between" // Pushes text to the left, icon to the right
          }}
          
        >
          <a style={{
              flex: 1,               // Allows text to take up remaining space
              height: 'auto',
              color: isTouching ? 'blue' : 'black',
              fontSize: mode === 1 ? '3vh' : mode === 2 ? '2vh' : undefined
            }}
            onClick={handleImageClick}
            onTouchEnd={handleTouchEnd}
            onTouchStart={handleTouchStart}>
            {text}
          </a>

          {mode === 2 && (
            <a style={{ 
                display: 'inline-flex', // Removes inline text baseline spacing completely
                alignItems: 'center',
                lineHeight: 0           // Kills any vertical font height inheritance
              }}
              onClick={(e) => {
                e.stopPropagation(); // Prevents triggering parent onClick when deleting
                e.preventDefault();
                SendMessage(`[{"type":"MSG_DELETE","index":${index}}]`);
              }} >
            <img 
              
              className="song-panelDelete" 
              style={{
                height: "20px",
                marginLeft: "8px",
                flexShrink: 0          // Prevents the icon from getting squashed if text wraps
              }} 
              alt="ListDelete" 
              src={icoDel}
            />
            </a>
          )}
        </div>

        {/* Separate border line container below the flex row */}
        <div style={{
            width: '100%',
            borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
            marginTop: '5px'
          }} 
        /></>
  )
}
